<template>
  <nav
    v-if="totalPages > 1"
    class="r-pagination navigation d-inline-block text-right"
  >
    <ul class="pagination">
      <li class="page-item">
        <button
          type="button"
          class="page-link"
          :class="{ disabled: isInFirstPage}"
          @click="onClickFirstPage"
          :disabled="isInFirstPage"
        >First</button>
      </li>

      <li class="page-item">
        <button
          type="button"
          class="page-link"
          :class="{ disabled: isInFirstPage}"
          @click="onClickPreviousPage"
          :disabled="isInFirstPage"
        >Previous</button>
      </li>

      <li v-for="page in pages" :key="page.name">
        <button
          type="button"
          class="page-link btn-primary"
          @click="onClickPage(page.name)"
          :disabled="page.isDisabled"
        >{{ page.name }}</button>
      </li>

      <li class="page-item">
        <button
          type="button"
          class="page-link"
          :class="{ disabled: isInLastPage}"
          @click="onClickNextPage"
          :disabled="isInLastPage"
        >Next</button>
      </li>

      <li class="page-item">
        <button
          type="button"
          class="page-link"
          :class="{ disabled: isInLastPage}"
          @click="onClickLastPage"
          :disabled="isInLastPage"
        >Last</button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      default: 3
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },

  computed: {
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }
      // When on the last page
      if (this.currentPage === this.totalPages && this.totalPages > this.maxVisibleButtons) {
        return this.totalPages - this.maxVisibleButtons + 1;
      }

      // When in between
      return this.currentPage - 1;
    },
    pages() {
      const range = [];
      const lastPageInRange = Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      );

      for (let i = this.startPage; i <= lastPageInRange; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }

      return range;
    }
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pageChanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pageChanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pageChanged', page);
    },
    onClickNextPage() {
      this.$emit('pageChanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pageChanged', this.totalPages);
    }
  }
};
</script>

<style lang="scss">
  button.page-link {

    &.disabled {
      opacity: .5;
      cursor: not-allowed;
    }
  }
</style>
